module.exports = __webpack_public_path__ + "img/Kibe25.06ed0641.jpg";